import userCommentApi from '@/api/userCommentAPI'

// Note counts per hold for the member list's note icons. The notes
// themselves are loaded by UserCommentsPanel when it opens.
export const userCommentStore = {
    namespaced: true,

    state: {
        // { [group_id]: { [user_id]: count } }
        counts: {},
    },

    mutations: {
        SET_COUNTS(state, { group_id, counts }) {
            state.counts = { ...state.counts, [group_id]: counts || {} }
        },
    },

    actions: {
        async fetchCommentCounts({ commit }, group_id) {
            const response = await userCommentApi.fetchCommentCounts(group_id)
            commit('SET_COUNTS', { group_id, counts: response.data })
            return response
        },

        async fetchComments(context, { user_id, group_id }) {
            const response = await userCommentApi.fetchComments({ user_id, group_id })
            return response.data
        },

        async addComment(context, payload) {
            const response = await userCommentApi.addComment(payload)
            return response.data
        },

        async updateComment(context, payload) {
            const response = await userCommentApi.updateComment(payload)
            return response.data
        },

        async deleteComment(context, id) {
            return await userCommentApi.deleteComment(id)
        },
    },

    getters: {
        commentCount: state => (group_id, user_id) => {
            const counts = state.counts[group_id]
            return (counts && counts[user_id]) || 0
        },
    },
}
